<template>
  <div class="leads">
    <div v-if="showBasket" id="basketWidget"></div>
    <search />
  </div>
</template>

<script>
import Search from './Search'

export default {
  name: 'Leads',
  components: { Search },
  props: {
    showBasket: Boolean,
  },
}
</script>

<style>
.leads {
  display: flex;
  align-items: center;
  gap: 0 var(--spacing-4);
  min-height: 20px;
}

@media (--lg) {
  .leads {
    min-height: 50px;
    justify-self: flex-end;
  }
}
</style>
